export default {
  plural: 'Notifications'
};
